module.exports = __webpack_public_path__ + "img/location-icon.fac70a00.svg";